import CreatorsPage from "./CreatorsPage"

export default CreatorsPage
